export default __webpack_public_path__ + "static/media/feature-website-2.da371c9f.png";